// Converted version of the provided React Native utility code for React.js

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// You can show custom alerts using toast
const CustomAlert = (title, description, modal) => {
  const config = {
    position:
      modal === "modal"
        ? toast.POSITION.TOP_CENTER
        : toast.POSITION.BOTTOM_RIGHT,
    autoClose: 2000,
  };
  toast(`${title}: ${description}`, config);
};







const logout = (navigate) => {
  const confirmed = window.confirm("Are you sure you want to logout?");
  if (confirmed) {
    localStorage.clear();
    navigate("/login");
  }
};


const planetsData = [
  {
    Planet: "Sun",
    Friends: ["Moon", "Mars", "Jupiter"],
    Enemies: ["Saturn", "Venus", "Rahu"],
    Neutral: ["Mercury", "Ketu"],
  },
  {
    Planet: "Moon",
    Friends: ["Sun", "Mercury"],
    Enemies: ["-"],
    Neutral: ["Mars", "Jupiter", "Venus", "Saturn", "Rahu", "Ketu"],
  },
  {
    Planet: "Mars",
    Friends: ["Sun", "Moon", "Jupiter"],
    Enemies: ["Mercury"],
    Neutral: ["Venus", "Saturn", "Rahu", "Ketu"],
  },
  {
    Planet: "Mercury",
    Friends: ["Sun", "Venus"],
    Enemies: ["Moon", "Ketu"],
    Neutral: ["Jupiter", "Mars", "Rahu", "Saturn"],
  },
  {
    Planet: "Jupiter",
    Friends: ["Sun", "Moon", "Mars"],
    Enemies: ["Venus", "Mercury", "Rahu"],
    Neutral: ["Saturn", "Ketu"],
  },
  {
    Planet: "Venus",
    Friends: ["Saturn", "Mercury", "Rahu"],
    Enemies: ["Sun", "Moon"],
    Neutral: ["Jupiter", "Mars", "Ketu"],
  },
  {
    Planet: "Saturn",
    Friends: ["Mercury", "Venus", "Rahu"],
    Enemies: ["Sun", "Moon", "Mars"],
    Neutral: ["Jupiter", "Ketu"],
  },
  {
    Planet: "Rahu",
    Friends: ["Venus", "Saturn"],
    Enemies: ["Sun", "Moon", "Mars"],
    Neutral: ["Mercury", "Jupiter", "Ketu"],
  },
  {
    Planet: "Ketu",
    Friends: ["Sun", "Mars"],
    Enemies: ["Venus", "Saturn"],
    Neutral: ["Mercury", "Jupiter", "Moon", "Rahu"],
  },
];

export {
  CustomAlert,
  logout,
  planetsData,
};
